import { connect } from "react-redux";
import WorkInstructionsPage from "./WorkInstructionsPage"
import { fetchAllUsers, assignUsers } from "../../../redux/actions/user_actions"
import { fetchAllWorkInstructions, editWorkInstruction, previewWorkInstruction, cloneWorkInstruction, saveWorkInstruction, selectWorkInstruction, updateWorkInstruction } from "../../../redux/actions/wi_actions"
import { fetchAllTags } from '../../../redux/actions/tag_actions';
import { deleteWorkInstruction, clearAuthor } from "../../../redux/actions/wi_actions"

const mapStateToProps = (state) => {
    return ({
        author: state.author.current,
        workInstructions: state.work_instructions.all,
        tags: state.tags,
        users: state.users
    });
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return ({
        assignUsers: (assignments, workInstructionId) => dispatch(assignUsers(assignments, workInstructionId)),
        fetchAllTags: (cancelToken) => dispatch(fetchAllTags(cancelToken)),
        fetchAllWorkInstructions: (cancelToken) => dispatch(fetchAllWorkInstructions(cancelToken)),
        fetchAllUsers: (cancelToken) => dispatch(fetchAllUsers(cancelToken)),
        fetchWorkInstructionForEdit: (WIID) => dispatch(editWorkInstruction(WIID, false)),
        selectWorkInstruction: (WIID) => dispatch(editWorkInstruction(WIID, false)),
        cloneWorkInstruction: (workInstructionId) => dispatch(cloneWorkInstruction(workInstructionId)),
        deleteWorkInstruction: (workInstructionId) => dispatch(deleteWorkInstruction(workInstructionId)),
        previewWorkInstruction: (WIID) => dispatch(previewWorkInstruction(WIID)),
        clearAuthor: () => dispatch(clearAuthor()),
        saveWorkInstruction: (wi) => dispatch(saveWorkInstruction(wi)),
        setAuthorForEditing: (wi) => dispatch(selectWorkInstruction(wi)),
        updateWorkInstruction: (wi) => dispatch(updateWorkInstruction(wi)),
    });
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkInstructionsPage);